import React from "react"
import { NotificacaoPush } from "./NotificacaoPush"

export function Index() {
    return <NotificacaoPush />
}
